import { combineReducers } from "redux";

import { addonsCategoryDetails } from "./reducer.addonCategory"
const addonsCategoryReducers = combineReducers({

    addonsCategoryDetails

})
export default addonsCategoryReducers;
